import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function Approach() {
  const { t } = useTranslation(['approach']);

  return (
    <section id="approach" className="section band-forest approach">
      <div className="section-head">
        <h2 className="section-title">{t('approach:title')}</h2>
        <p className="section-lede">{t('approach:lede')}</p>
      </div>

      <div className="habits">
        {profile.habits.map((habit, index) => (
          <div key={habit} className={`habit${index === 0 ? ' habit--first' : ''}`}>
            <div className="habit__number" dir="ltr">
              {String(index + 1).padStart(2, '0')}
            </div>
            <h3 className="habit__title">{t(`approach:habits.${habit}.title`)}</h3>
            <p className="habit__text">{t(`approach:habits.${habit}.body`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
